import { SeasonProcessState } from '@coin/shared/core/util-enums';

export class SeasonHelper {
  public static isReadonly(season: { state?: SeasonProcessState }): boolean {
    return season?.state === SeasonProcessState.Paused;
  }
}
